import React from 'react'
import { Pages } from '../Pages'
import { MenuItems } from '../enums/MenuItems'
import Button from '../components/Button'
import LayoutSingleView from '../components/layout/LayoutSingleView'
import { useSafeUserData } from '../stateStores/User'
import { UserRoles } from '../api/tenant/models/UserDto'

function AccessDenied(): React.JSX.Element {
    const { user } = useSafeUserData()
    const activeMembership = user.memberships.find(
        (membership) => membership.tenantId === user.activeTenantId,
    )
    const hasOnlyJobSeekerRole = Boolean(
        activeMembership?.roles.length &&
        activeMembership.roles.every((role) => role === UserRoles.JOB_SEEKER),
    )

    if (hasOnlyJobSeekerRole) {
        return (
            <LayoutSingleView activeMenuItem={MenuItems.Roles}>
                <div className="flex justify-center mt-24">
                    <div className="text-center max-w-xl space-y-4">
                        <img
                            src="access_denied.svg"
                            className="w-1/2 mx-auto"
                            alt="Job seeker"
                        />
                        <p className="text-gray-700 text-xl font-semibold">
                            Job seeker tools are coming soon!
                        </p>
                        <p className="text-gray-600">
                            We're building more in-app experiences for you, but
                            in the meantime feel free to keep chatting with Kit.
                        </p>
                        <Button
                            style="primary"
                            type="link"
                            to={Pages.CandidateLandingOption1}
                            classes="mt-2"
                        >
                            Chat with Kit
                        </Button>
                    </div>
                </div>
            </LayoutSingleView>
        )
    }

    return (
        <LayoutSingleView activeMenuItem={MenuItems.Roles}>
            <div className="flex justify-center mt-24">
                <div className="text-center">
                    <img src="access_denied.svg" className="w-1/2 mx-auto" />
                    <p className="mt-4 text-gray-700 text-xl">
                        You do not have permissions to access this page.
                    </p>
                    <Button
                        style="primary"
                        type="link"
                        to={Pages.Roles}
                        classes="mt-4"
                    >
                        View Roles
                    </Button>
                </div>
            </div>
        </LayoutSingleView>
    )
}

export default AccessDenied
